import React from 'react';
import SubsidiaryCard from './SubsidiaryCard';

const Subsidiaries = ({ title, subsidiaries }) => {
  const defaultSubsidiaries = [
    {
      name: 'Gardamor ISP',
      description: 'High-performance internet services for residential and business clients, focusing on reliability and exceptional customer support.',
      link: '#gardamorisp',
      logoPlaceholder: process.env.PUBLIC_URL + '/images/4.jpeg'
    },
    {
      name: 'Baniuaga Construction',
      description: 'Innovative construction solutions with a commitment to quality, sustainability, and cutting-edge architectural design.',
      link: '#construction',
      logoPlaceholder: process.env.PUBLIC_URL + '/images/5.jpg'
    },
    {
      name: 'Rozi Tours & Travel',
      description: 'Premium travel services offering curated tour packages and personalized travel experiences for discerning travelers.',
      link: '#rozi-tours',
      logoPlaceholder: process.env.PUBLIC_URL + '/images/6.avif'
    },
    {
      name: 'Gardamor Security',
      description: 'Comprehensive security solutions for businesses and residences with trained personnel and advanced security systems.',
      link: '#gardamor-security',
      logoPlaceholder: process.env.PUBLIC_URL + '/images/3.jpeg'
    },
    {
      name: 'Rozi Fuel',
      description: 'Reliable fuel distribution services with a commitment to quality, safety, and environmental responsibility.',
      link: '#rozi-fuel',
      logoPlaceholder: process.env.PUBLIC_URL + '/images/2.jpeg'
    },
    {
      name: 'Rozi Construction',
      description: 'Professional construction services with expertise in residential, commercial, and industrial projects.',
      link: '#rozi-construction',
      logoPlaceholder: process.env.PUBLIC_URL + '/images/1.jpg'
    }
  ];

  const subsidiariesToDisplay = subsidiaries || defaultSubsidiaries;

  return (
    <section id="subsidiaries" className="section-spacing bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-brand-900 sm:text-5xl">
            {title || 'Our Subsidiaries'}
          </h2>
          <div className="w-24 h-1 bg-accent-500 mx-auto mt-4 mb-8"></div>
          <p className="max-w-3xl mx-auto text-xl text-neutral-700 mb-16">
            Discover our specialized business units, each delivering excellence in their respective fields
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {subsidiariesToDisplay.map((subsidiary, index) => (
            <SubsidiaryCard 
              key={index}
              name={subsidiary.name}
              description={subsidiary.description}
              link={subsidiary.link}
              logoPlaceholder={subsidiary.logoPlaceholder}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Subsidiaries;